import { getEnvironment as u, CONSTs as c, parseQuery as g } from "./utils/common-utils.js";
const d = {
  TYPE_ANALYTICS_CUSTOM_EVENT: "triggerAnalytics"
}, w = {
  NAV: "nav",
  NAV_TRAY: "navtray",
  BREADCRUMB: "breadcrumb"
};
class l {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
  }
  setSatelliteTrack(e = "", n = "") {
    return window._satellite && typeof window._satellite.track == "function" && e && n && window._satellite.track(e, n), !0;
  }
  ping(e, n, s, t = "link") {
    let a = t;
    if (!e || typeof e != "string" || e.length < 1) {
      console.warn("analytics.ping() received an invalid message. message must be a string.");
      return;
    }
    if (!n || typeof n != "string" || n.length < 1) {
      console.warn("analytics.ping() received an invalid href. href must be a string.");
      return;
    }
    if ((!s || typeof s != "string" || s.length < 1) && console.warn("analytics.ping() received no siteId."), !t || typeof t != "string" || t.length < 1) {
      console.warn(
        "analytics.ping() received an invalid Ping Source Type. Ping Source Type must be a string."
      );
      return;
    }
    a = a.toLowerCase(), this.pingCustomEvent(e, n, s, a, d.TYPE_ANALYTICS_CUSTOM_EVENT);
  }
  pingCustomEvent(e, n, s, t, a) {
    let i;
    const o = { detail: {} };
    o.detail = { message: e, href: n, siteId: s, type: t };
    try {
      i = new CustomEvent(a, o);
    } catch {
      i = document.createEvent("CustomEvent"), i.initCustomEvent(a, !1, !1, o);
    }
    document.body.dispatchEvent(i);
  }
}
const m = (r) => {
  var e;
  return !((e = r.HstMenuItemRepresentation.menuItems) != null && e.length) || r.HstMenuItemRepresentation.parameters.showDropdown !== "true" ? 0 : r.HstMenuItemRepresentation.menuItems.length + r.HstMenuItemRepresentation.menuItems.reduce(
    (n, s) => n + m(s),
    0
  );
}, h = (r) => {
  const e = window.location.href.toLowerCase(), n = u();
  let s = "";
  if (e && n !== c.UNKNOWN && n !== c.PREVIEW) {
    const t = e.split("/");
    if (t != null && t.length && t.length > 1) {
      const a = t[n !== c.LOCAL ? 2 : 4];
      a && a.length > 1 && r.forEach((i) => {
        var o;
        e.includes((o = i.HstMenuItemRepresentation.url) == null ? void 0 : o.toLowerCase()) && (s = i.HstMenuItemRepresentation.name);
      });
    }
  }
  return s;
}, C = (r, e, n, s) => {
  if (!n)
    return;
  const { href: t } = r.target;
  let a = "";
  if (t && t !== null && t.indexOf("&siteid") > -1 && (a = g(t).siteid.split("#")[0]), s)
    try {
      new l().setSatelliteTrack(s, t);
    } catch (i) {
      console.error(i);
    }
  try {
    new l().ping(n, t, a, e);
  } catch (i) {
    console.warn(i);
  }
};
export {
  w as A,
  m as a,
  h as g,
  C as h
};
//# sourceMappingURL=common-utils-DEsnppYk.mjs.map
